<template>
  <dl class="region-intro" :style="style">
    <dt>
      <span class="name">{{ value.areaName || '当前区域' }}</span>
      <span class="close" title="关闭" @click="close">关闭</span>
    </dt>
    <dd>
      <div class="bg"></div>
      <div class="sub-title" v-if="value.date">
        <span title="日期">{{ value.date ?? '--' }}</span>
      </div>
      <ul>
        <li v-if="!value || !value.attrs || !value.attrs.length" data-label="暂无数据">无相关数据</li>
        <li v-for="(v, i) in value.attrs" :key="i">
          <span class="label" :class="{ [labelAlign]: labelAlign }" :style="{ width: labelAlign != 'left' ? labelMaxWidth : 'auto' }">{{ v.label }}</span>
          <span class="value">{{ v.value ?? '--' }}{{ v.unit ?? '' }}</span>
        </li>
        <!--
        <li data-label="小麦种植面积" data-unit="亩">232323</li>
        <li data-label="预估已完成收割面积约" data-unit="亩">232323</li>
        <li data-label="预估漯河市收割进度" data-unit="%">232323</li>
        -->
      </ul>
    </dd>
  </dl>
</template>

<script>
export default {
  name: 'RegionIntroDialog',
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      position: [0, 0], // x,y
    };
  },
  computed: {
    style() {
      let self = this;
      return {
        left: self.position[0] + 'px',
        top: self.position[1] + 'px',
      };
    },
    labelAlign() {
      let self = this;
      return self.value?._labelAlign ?? 'left';
    },
    labelMaxWidth() {
      let self = this;
      let w = 1;
      (self.value?.attrs || []).forEach((element) => {
        if (element.label.length > w) {
          w = element.label.length;
        }
      });
      return `${w + 1}em`;
    },
  },
  methods: {
    setPosition(position) {
      let self = this;
      self.position = position;
    },
    close() {
      let self = this;
      self.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 1920) * 100vw;
}
@function vh($px) {
  @return ($px / 1080) * 100vh;
}
@function fontSize($px) {
  @return 100vw * $px / 1920;
}
.region-intro {
  pointer-events: none;
  user-select: none;
  position: fixed;
  left: 50%;
  top: 50%;
  width: vw(243);
  box-sizing: content-box;
  transform: translate(0, -100%);
  transition: all 0.2s ease-in-out;
  dt {
    padding: vh(18) vw(18) 0;
    height: vh(30);
    line-height: vh(28);
    box-sizing: content-box;
    background: url(../images/bg_tk_bf_con_u.png) no-repeat top left;
    background-size: 100% 100%;
    position: relative;
    span.name {
      font-size: fontSize(16);
      font-style: italic;
      font-weight: bold;
      text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);
      padding-left: 0.3em;
    }
    span.close {
      pointer-events: all;
      display: block;
      width: vw(13);
      height: vh(12);
      background: url(../images/bg_tk_bf_con_close.png);
      background-size: 100% 100%;
      text-indent: -9999px;
      overflow: hidden;
      position: absolute;
      right: vw(22);
      top: vh(26);
      cursor: pointer;
      &:hover {
        opacity: 0.9;
      }
      &:active {
        transform: translate(1px, 1px);
      }
    }
  }
  dd {
    padding: 0 vw(18) vh(18);
    font-size: fontSize(14);
    box-sizing: content-box;
    position: relative;
    color: #c7ffdb;
    .sub-title {
      font-size: fontSize(14);
      padding: vh(8) vw(8) 0;
      // backdrop-filter: blur(2px);
    }
    ul {
      list-style: none;
      padding: vh(4) vw(8) vh(8);
      margin: 0;
      // backdrop-filter: blur(2px);
      li {
        margin: 0;
        padding: 0;
        span {
          white-space: nowrap;
        }
        .label {
          text-align: right;
          display: inline-block;
          color: #3db868;
          &::after {
            content: '：';
          }
        }
        .value {
          color: #fff;
        }
      }
    }
    div,
    ul {
      position: relative;
      z-index: 1;
    }
    .bg {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      &::before,
      &::after {
        content: '';
        display: block;
      }
      &::before {
        flex: 1;
        background: url(../images/bg_tk_bf_con_u_body.png) repeat-y left top;
        background-size: 100% 100%;
      }
      &::after {
        height: vh(87);
        background: url(../images/bg_tk_bf_con_u_footer.png) no-repeat left top;
        background-size: 100% 100%;
      }
    }
  }
}
</style>
